import { ERROR_TYPES, ERROR_MESSAGES } from './MessageTypes';
import { logger } from '@/utils/logger';

/**
 * Iframe错误处理器
 * 负责处理各种错误情况
 */
export class IframeErrorHandler {
  /**
   * 处理会话切换错误
   * @param {string} error - 原始错误信息
   * @returns {Object} 处理后的错误信息
   */
  handleSwitchConversationError(error) {
    let errorMessage = ERROR_MESSAGES.SWITCH_CONVERSATION_FAILED;
    let errorType = ERROR_TYPES.ERROR;

    if (error) {
      if (error.includes('only group member') || error.includes('不是群组成员')) {
        errorMessage = '您不是该群组的成员，无法访问此会话。请联系管理员将您添加到群组中。';
        errorType = ERROR_TYPES.WARNING;
      } else if (error.includes('invalid group id') || error.includes('群组ID无效')) {
        errorMessage = '群组ID无效，该群组可能已被删除或不存在。';
        errorType = ERROR_TYPES.ERROR;
      } else if (error.includes('会话 ID 无效') || error.includes('invalid conversation id')) {
        errorMessage = '会话ID格式无效，请检查会话配置。';
        errorType = ERROR_TYPES.ERROR;
      } else if (error.includes('权限') || error.includes('permission')) {
        errorMessage = '您没有权限访问此会话，请联系管理员获取相应权限。';
        errorType = ERROR_TYPES.WARNING;
      }
    }

    return {
      errorMessage,
      errorType,
      originalError: error,
    };
  }

  /**
   * 验证初始化参数
   * @param {Object} params - 初始化参数
   * @returns {Object} 验证结果
   */
  validateInitParams(params) {
    const { iframe, credentials, conversationId } = params;
    const errors = [];

    if (!iframe) {
      errors.push(ERROR_MESSAGES.IFRAME_NOT_EXISTS);
    } else if (!iframe.contentWindow) {
      errors.push(ERROR_MESSAGES.IFRAME_NOT_CONFIGURED);
    }

    if (!conversationId) {
      errors.push(ERROR_MESSAGES.MISSING_CONVERSATION_ID);
    }

    if (!credentials) {
      errors.push(ERROR_MESSAGES.MISSING_CREDENTIALS);
    }

    return {
      isValid: errors.length === 0,
      errors,
    };
  }

  /**
   * 验证切换会话参数
   * @param {Object} params - 切换会话参数
   * @returns {Object} 验证结果
   */
  validateSwitchConversationParams(params) {
    const { iframe, conversationId, serviceUserId } = params;
    const errors = [];

    if (!iframe) {
      errors.push(ERROR_MESSAGES.IFRAME_NOT_EXISTS);
    }

    if (!conversationId) {
      errors.push(ERROR_MESSAGES.MISSING_CONVERSATION_ID);
    }

    if (!serviceUserId) {
      errors.push(ERROR_MESSAGES.MISSING_SERVICE_USER_ID);
    }

    return {
      isValid: errors.length === 0,
      errors,
    };
  }

  /**
   * 记录错误日志
   * @param {string} context - 错误上下文
   * @param {Object} errorData - 错误数据
   */
  logError(context, errorData) {
    logger.error(`[IframeErrorHandler] ${context}`, errorData);
  }

  /**
   * 记录警告日志
   * @param {string} context - 警告上下文
   * @param {Object} warningData - 警告数据
   */
  logWarning(context, warningData) {
    logger.warn(`[IframeErrorHandler] ${context}`, warningData);
  }
}
